import { css } from "@styled-system/css";

export const styles = {
  root: css({}),
};
